import React from 'react';
import PropTypes from 'prop-types';
import * as InfoMessage from '../../../constants/common/InfoMessage';
// import * as InfoMessage from '~/src/constants/common/InfoMessage';

/**
 * InfoComments
 */
class InfoComments extends React.Component {

  render() {
    const msgId = this.props.msgID;
    const message = InfoMessage.INFO_MESSAGE.filter((item) => {
      return (item.code == msgId);
    });
    const comments = <p className="info_message">{message[0].message}</p>;

    return (
      <div className="cf info_comments">
        {comments}
      </div>
    );
  }
}

InfoComments.propTypes = {
  msgID: PropTypes.string.isRequired
};

export default InfoComments;
